import { Button, ButtonStyles, Icons, showAlert } from '@silverfort/sf-components';
import React, { FC, useCallback } from 'react';
import { InsightEntitiesFilters } from '../api/queries/useGetInsightEntities';
import useGenerateInsightEntitiesFile from '../api/queries/useGenerateInsightEntitiesFile';
import { RISK_RULES } from '@silverfort-nodelibs/common/utils/insight';
import ExportShadowAdminsData from './ShadowAdminsExportData';

interface Props {
    insightTitle?: string;
    insightRuleName: string;
    filters: InsightEntitiesFilters;
}

const ExportButton: FC<Props> = ({ insightTitle, filters, insightRuleName }) => {
    const onExportFileError = useCallback(() => {
        showAlert(`Failed to export ${insightTitle ?? insightRuleName} entities`, 'error');
    }, [insightTitle, insightRuleName]);

    const { isGenerating, downloadCsv } = useGenerateInsightEntitiesFile({
        onError: onExportFileError,
        fileName: `${insightTitle ?? insightRuleName}_exposure_investigation`
    });

    const onExportClicked = useCallback(() => {
        const csvFilters = { ...filters };
        delete csvFilters.pageSize;

        downloadCsv(insightRuleName, csvFilters);
    }, [insightRuleName, filters]);

    return insightRuleName === RISK_RULES.SHADOW_ADMIN ? (
        <ExportShadowAdminsData exportDisplayedData={onExportClicked}></ExportShadowAdminsData>
    ) : (
        <Button
            className="text-13 font-medium font-sf"
            text="Export"
            onClick={onExportClicked}
            disabled={isGenerating}
            iconLeft={Icons.Download}
            buttonStyle={ButtonStyles.Primary}
        />
    );
};

export default ExportButton;
